import { createContext, useContext } from 'react';

import { ThemeColors } from './config/colors';
import { ThemeFonts } from './config/fonts';

export type Theme = {
  colors: ThemeColors;
  fonts: ThemeFonts;
};

export const ThemeContext = createContext<Theme | null>(null);

export function useTheme() {
  const context = useContext(ThemeContext);

  if (!context) {
    throw new Error('Invalid hook call');
  }

  return context;
}
